export default __webpack_public_path__ + "static/media/image_full_50.7b873939.svg";